import { render, staticRenderFns } from "./FooterTagForm.vue?vue&type=template&id=5cd86aa3&"
import script from "./FooterTagForm.vue?vue&type=script&lang=ts&"
export * from "./FooterTagForm.vue?vue&type=script&lang=ts&"
import style0 from "./FooterTagForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports